import { Injectable } from '@angular/core';
import {Router} from "@angular/router";
import { UsersService } from '../users.service';
import { AppService } from '../../app/services/app.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(private UsersService: UsersService, private router: Router, private appService: AppService) { }


  IsAdminLogin():Promise<boolean>{
    return new Promise((resolve, reject) => {
      if(!this.IsLoggedIn()){
        this.router.navigate(['/'],{ queryParams: {loginOpenForm:true } });
          resolve(false)
      }else{
        this.UsersService.getIsSuperuser().subscribe((res:any)=>{
          if(res['is_superuser']){
            localStorage.setItem("is_superuser", res['is_superuser']);
            resolve(res['is_superuser'])
          }else{
            this.router.navigate(['/'],{ queryParams: { } }).then(()=>{
              window.location.reload();
            });
          }
        },error => {
          this.router.navigate(['/'],{ queryParams: { } }).then(()=>{
            window.location.reload();
          });
        })
      }
    })
  }

  isSuperUser(): boolean{
    return localStorage.getItem('is_superuser') == 'true';
  }
  IsLoggedIn(){
    const role = localStorage.getItem('role');
    const isAdmin = role === 'admin';
    const isTeacher = role === 'teacher';
    this.appService.setAdmin(isAdmin);
    this.appService.setEditor(isTeacher || isAdmin);
    return !!localStorage.getItem('token')
  }
}
